import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import ConfigContext from '../../../contexts/ConfigContext';

import styles from './Blog.module.postcss';

dayjs.extend(advancedFormat);

function BlogPostTease({ blogPost }) {
  const { imageBase } = useContext(ConfigContext);

  const date = dayjs(blogPost.post_date).format('dddd, MMMM Do');
  const image = blogPost.photo
    ? `${imageBase}/${blogPost.photo}`
    : '/static/images/truck-placeholder.png';

  return (
    <Link className={styles.BlogPostTease} to={`/blog/${blogPost.id}`}>
      <img
        className={styles.BlogPostTease_image}
        src={image}
        alt={blogPost.title}
        loading='lazy'
        fetchpriority='low'
      />

      <div className={styles.BlogPostTease_info}>
        <div className='u-strong u-mb05'>{blogPost.title}</div>
        <div>
          <img src='/static/images/icons/cal.svg' alt='' width='16' height='17' aria-hidden='true' />
          <div>{date}</div>
        </div>
      </div>
    </Link>
  );
}

BlogPostTease.propTypes = {
  blogPost: PropTypes.object.isRequired,
};

export default BlogPostTease;
